import { createActionGroup, props } from '@ngrx/store';

export const PoiSelectPaymentMethodAutopayActions = createActionGroup({
  source: 'POI Select Payment Method Component Autopay',
  events: {
    'Check Autopay Eligibility': props<{
      tenantId: string;
      accountNumbers: string[];
    }>(),
  },
});
